<template>
  <v-row no-gutters justify="center" :class="{ 'table-buttons-assign-multiple-parcels-box': isActive }">
    <v-col cols="auto">
      <table-button
        name="button-assign-multiple-parcels-rotate"
        v-bind="{ ...$props, ...$attrs, tooltip: isActive ? '' : tooltip, disableCursor: isActive }"
        v-on="mainButtonListeners"
        :is-loading="isLoading"
        :buttonSize="isActive ? 'small' : 'default'"
      />
    </v-col>
    <v-col cols="auto" v-if="isActive">
      <table-button
        name="button-assign-multiple-parcels-accept"
        v-bind="secondaryButtons"
        icon="mdi-check"
        color="success"
        :tooltip="isLoading ? '' : $i18n.t('button.assignMultipleParcelsAccept')"
        @click="accept"
      />
      <table-button
        name="button-assign-multiple-parcels-reject"
        v-bind="secondaryButtons"
        icon="mdi-close"
        color="error"
        :tooltip="isLoading ? '' : $i18n.t('button.assignMultipleParcelsReject')"
        @click="toggle"
      />
    </v-col>
  </v-row>
</template>

<script>
import TableButton from '@/components/TableButton';
import { sync } from 'vuex-pathify';

export default {
  name: 'TableButtonsAssignMultipleParcels',
  components: {
    TableButton,
  },
  props: {
    isActive: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    geometryType: {
      type: String,
      required: true,
    },
    tooltip: {
      type: String,
    },
    layer: {
      type: [Number, String],
      required: true,
    },
  },
  computed: {
    isAssignMultipleParcelButtonActive: sync('edit/isAssignMultipleParcelButtonActive'),
    mainButtonListeners() {
      return {
        ...(this.isActive ? {} : { click: this.toggle }),
      };
    },
    secondaryButtons() {
      return {
        disabled: this.isLoading,
        fontSize: '19px',
        buttonSize: 'small',
      };
    },
  },
  methods: {
    accept() {
      this.$root.$emit('getLayerContextById', {
        id: 'drawingSidebarLayer',
        callback: layer => {
          if (layer?.getSource().getFeatures().length) {
            this.isAssignMultipleParcelButtonActive = false;
            this.$root.$emit('finishAssigningGeometry', this.geometryType, this.layer);
          } else {
            this.$store.set('snackbar/PUSH_MESSAGE!', {
              message: this.$i18n.t('snackbar.noPlotGeometry'),
            });
          }
        },
      });
    },
    toggle() {
      this.$emit('toggle');
    },
  },
};
</script>
<style lang="scss" scoped>
.table-buttons-assign-multiple-parcels-box {
  border-radius: 5px;
  background-color: map-get($colors, 'primarybackground');
}
</style>
